module.exports = __webpack_public_path__ + "static/media/sleepyDragonFrame2.91c9941f.png";